import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "../../webcss/invoice.css";
import { GET_UPI_ATM_TRANSACTION_DETAIL } from "../../Utils/appConstants";
import { getUTCToLocalDateTimeFormat } from "../../Utils/function";
import { getRequest } from "../../Utils/AppApi";
import PropagateLoader from "react-spinners/PropagateLoader";

function UpiAtmInvoice(props) {
  const history = useHistory();

  const [idata, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [isPrintButton, setPrintButton] = useState(true);

  const { isPageView = false, transactionId } = props;

  const print = () => {
    setPrintButton(false);
    setTimeout(() => {
      window.print();
      setPrintButton(true);
    }, 100);
  };

  const handleInvoice = () => {
    setLoading(true);
    getRequest(`${GET_UPI_ATM_TRANSACTION_DETAIL}?ipayId=${transactionId}`, history)
      .then((response) => {
        if (response.success) setData(response.data || {});
        else setData({});
      })
      .catch(() => setData({}))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (transactionId) handleInvoice();
  }, [transactionId]);

  const getStatusBadge = (status) => {
    const c = {
      INITIATED: { t: '⏳ Initiated', c: '#1890ff', b: '#e6f7ff', r: '#91d5ff' },
      SUCCESS: { t: '✅ Success', c: '#389e0d', b: '#f6ffed', r: '#b7eb8f' },
      FAILED: { t: '❌ Failed', c: '#cf1322', b: '#fff2f0', r: '#ffccc7' },
      EXPIRED: { t: '⏰ Expired', c: '#d48806', b: '#fffbe6', r: '#ffe58f' }
    };
    return c[status] || { t: status || 'Unknown', c: '#8c8c8c', b: '#fafafa', r: '#d9d9d9' };
  };

  const maskVpa = (vpa) => {
    if (!vpa) return { n: '', h: '' };
    const i = vpa.indexOf('@');
    if (i === -1) return { n: vpa, h: '' };
    const name = vpa.substring(0, i), handle = vpa.substring(i);
    let m = name.length <= 2 ? name + '***' : name.length <= 4 ? name.substring(0, 2) + '***' : name.substring(0, 2) + '***' + name.slice(-1);
    return { n: m, h: handle };
  };

  const s = getStatusBadge(idata?.status);
  const v = maskVpa(idata?.payerVpa);

  const isSuccess = idata?.status === 'SUCCESS';
  const isFailed = idata?.status === 'FAILED';
  const refundNote = "Transaction Failed If money was deducted from customer account, don’t worry. It will be refunded within 7 working days.";

  if (loading) {
    return (
      <div style={{ background: '#f0f2f5', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <PropagateLoader color="#C9262C" size={15} />
      </div>
    );
  }

  const Row = ({ label, value, color, small }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #f5f5f5' }}>
      <span style={{ fontSize: '11px', color: '#999', fontWeight: 500 }}>{label}</span>
      <span style={{ fontSize: small ? '11px' : '12px', color: color || '#333', fontWeight: 500, textAlign: 'right', wordBreak: 'break-all', maxWidth: '65%' }}>{value || '-'}</span>
    </div>
  );

  const Dot = ({ color }) => (
    <div style={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
  );

  return (
    <div style={{ background: '#f0f2f5', minHeight: '100vh', padding: '16px' }}>
      <style>{`@media print { .np { display: none !important; } body { background: #fff !important; } }`}</style>

      <div style={{ maxWidth: '520px', margin: '0 auto', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        
        {/* Action Bar */}
        <div className="np" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 16px', borderBottom: '1px solid #f0f0f0', background: '#fafafa' }}>
          <button onClick={() => history.goBack()} style={{ background: '#fff', border: '1px solid #d9d9d9', borderRadius: '6px', padding: '6px 14px', cursor: 'pointer', fontSize: '12px', color: '#555' }}>
            <i className="fa fa-arrow-left" style={{ marginRight: 4 }}></i>Back
          </button>
          {isPrintButton && (
            <button onClick={print} style={{ background: '#C9262C', border: 'none', borderRadius: '6px', padding: '6px 14px', cursor: 'pointer', fontSize: '12px', color: '#fff' }}>
              <i className="fa fa-print" style={{ marginRight: 4 }}></i>Print
            </button>
          )}
        </div>

        <div style={{ padding: '18px 20px' }}>

          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', paddingBottom: '12px', borderBottom: '2px solid #f0f0f0' }}>
            <img src="../logo.png" alt="Logo" style={{ height: '36px', cursor: 'pointer' }} onClick={() => history.push('/dashboard')} />
            <div style={{ textAlign: 'right' }}>
              <h4 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: '#1a1a1a' }}>UPI QR Withdrawal</h4>
              <p style={{ margin: '1px 0 0', fontSize: '10px', color: '#999' }}>Ref: {idata?.externalRef || "N/A"}</p>
            </div>
          </div>

          {/* Status Badge */}
          <div style={{ textAlign: 'center', marginBottom: '14px', background: s.b, border: `1px solid ${s.r}`, borderRadius: '8px', padding: '8px' }}>
            <span style={{ color: s.c, fontWeight: 600, fontSize: '14px' }}>{s.t}</span>
          </div>

          {/* Amount - Centered */}
          <div style={{ textAlign: 'center', marginBottom: '14px', padding: '10px', background: '#fafafa', borderRadius: '10px', border: '1px solid #f0f0f0' }}>
            <div style={{ fontSize: '10px', color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px' }}>Amount</div>
            <div style={{ fontSize: '30px', fontWeight: 800, color: '#1a1a1a', lineHeight: 1.2 }}>₹{idata?.amount || 0}</div>
          </div>

          {/* Details Rows */}
          <div style={{ background: '#fafafa', borderRadius: '10px', border: '1px solid #f0f0f0', padding: '4px 14px', marginBottom: '12px' }}>
            <Row label="Customer Mobile" value={idata?.customerMobile} />
            <Row label="Customer Name" value={idata?.payerName || idata?.customerName} />
            {idata?.payerVpa && (
              <Row label="UPI VPA" value={<><b>{v.n}</b><span style={{color:'#C9262C',fontWeight:600}}>{v.h}</span></>} />
            )}
            <Row label="Account Number" value={idata?.payerAccountNumber} />
            <Row label="Bank RRN" value={idata?.operatorId} last />
          </div>

          {/* Timeline + Message in 2 columns */}
          <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
            
            {/* Timeline */}
            <div style={{ flex: 1, background: '#fafafa', borderRadius: '10px', border: '1px solid #f0f0f0', padding: '10px 14px' }}>
              <div style={{ fontSize: '10px', color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>Timeline</div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <Dot color="#1890ff" />
                <div>
                  <span style={{ fontSize: '9px', color: '#999', display: 'block' }}>Created</span>
                  <span style={{ fontSize: '11px', color: '#333', fontWeight: 500 }}>{idata?.createdAt ? getUTCToLocalDateTimeFormat(idata.createdAt) : "N/A"}</span>
                </div>
              </div>

              {idata?.completedAt && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <Dot color="#52c41a" />
                  <div>
                    <span style={{ fontSize: '9px', color: '#52c41a', display: 'block' }}>Completed</span>
                    <span style={{ fontSize: '11px', color: '#52c41a', fontWeight: 500 }}>{getUTCToLocalDateTimeFormat(idata.completedAt)}</span>
                  </div>
                </div>
              )}

              {idata?.failedAt && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <Dot color="#ff4d4f" />
                  <div>
                    <span style={{ fontSize: '9px', color: '#ff4d4f', display: 'block' }}>Failed</span>
                    <span style={{ fontSize: '11px', color: '#ff4d4f', fontWeight: 500 }}>{getUTCToLocalDateTimeFormat(idata.failedAt)}</span>
                  </div>
                </div>
              )}

              {idata?.expiredAt && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <Dot color="#faad14" />
                  <div>
                    <span style={{ fontSize: '9px', color: '#faad14', display: 'block' }}>Expired</span>
                    <span style={{ fontSize: '11px', color: '#faad14', fontWeight: 500 }}>{getUTCToLocalDateTimeFormat(idata.expiredAt)}</span>
                  </div>
                </div>
              )}

              {!idata?.completedAt && !idata?.failedAt && !idata?.expiredAt && (
                <span style={{ fontSize: '11px', color: '#bbb', fontStyle: 'italic' }}>Pending...</span>
              )}
            </div>

            {/* Message */}
            {(idata?.qrStatusMsg || isFailed) && (
              <div style={{ 
                flex: 1, textAlign: 'center', padding: '10px 14px', borderRadius: '10px',
                background: isSuccess ? '#f6ffed' : '#fff2f0',
                border: `1px solid ${isSuccess ? '#b7eb8f' : '#ffccc7'}`,
                display: 'flex', flexDirection: 'column', justifyContent: 'center'
              }}>
                {idata?.qrStatusMsg && (
                  <p style={{ margin: 0, fontSize: '11px', fontWeight: 500, color: isSuccess ? '#389e0d' : '#cf1322', lineHeight: 1.5 }}>
                    <i className="fa fa-info-circle" style={{ marginRight: 4 }}></i>
                    {idata.qrStatusMsg}
                  </p>
                )}

                {isFailed && (
                  <p style={{
                    margin: idata?.qrStatusMsg ? '8px 0 0' : 0,
                    paddingTop: idata?.qrStatusMsg ? '8px' : 0,
                    borderTop: idata?.qrStatusMsg ? '1px dashed #ffccc7' : 'none',
                    fontSize: '11px', fontWeight: 500, color: '#cf1322', lineHeight: 1.5
                  }}>
                    <i className="fa fa-clock-o" style={{ marginRight: 4 }}></i>
                    {refundNote}
                  </p>
                )}
              </div>
            )}
          </div>

          {/* Footer */}
          <div style={{ textAlign: 'center', paddingTop: '8px', borderTop: '1px solid #f0f0f0' }}>
            <p style={{ margin: 0, fontSize: '9px', color: '#ccc' }}>Computer generated receipt • No signature required</p>
          </div>

        </div>
      </div>
    </div>
  );
}

export default UpiAtmInvoice;